<div class="app-sidebar" [ngStyle]="{ width: sidebarWidth }">
  @if (sidebarConfiguration.foldable) {
    <div class="sidebar-toggle" (click)="toggleSidebar()">
      <i class="pi" [ngClass]="!collapsed ? 'pi-chevron-left' : 'pi-chevron-right'"></i>
    </div>
  }

  @if (!collapsed) {
    <div class="sidebar-upper-part">
      @if (headerTemplate) {
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      } @else {
        <div class="sidebar-header" *ngIf="sidebarConfiguration.header">{{ sidebarConfiguration.header }}</div>
        <div class="sidebar-sub-header" *ngIf="sidebarConfiguration.subHeader">
          {{ sidebarConfiguration.subHeader }}
        </div>
      }

      @if (isLoading) {
        <div class="sidebar-loader">
          @if (loaderTemplate) {
            <ng-container *ngTemplateOutlet="loaderTemplate"></ng-container>
          } @else {
            <i class="pi pi-spin pi-spinner"></i>
            <span>Loading...</span>
          }
        </div>
      } @else {
        <div class="sidebar-item-list">
          <ul>
            <li *ngFor="let item of sidebarConfiguration.items">
              @if (itemTemplate && item.useTemplate) {
                <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
              } @else {
                <strong class="sidebar-category" *ngIf="item.category"
                  ><i *ngIf="item.icon" class="{{ item.icon }}"></i>{{ item.label }}</strong
                >

                <div class="sidebar-divider" *ngIf="item.divider"></div>
                <div class="sidebar-spacer" *ngIf="item.spacer"></div>
                <span
                  class="sidebar-item"
                  *ngIf="!item.category && !item.divider && !item.spacer && !item.link"
                  (click)="item?.command()"
                  (auxclick)="handleMiddleClick($event, item)"
                  ><i *ngIf="item.icon" class="{{ item.icon }}"></i>{{ item.label }}</span
                >
                <a
                  class="sidebar-item"
                  *ngIf="!item.category && !item.divider && !item.spacer && item.link"
                  [attr.target]="isExternalLink(item.link) ? '_blank' : null"
                  [href]="item.link"
                  (click)="onItemLinkClick($event, item)"
                  (auxclick)="handleMiddleClick($event, item)"
                  ><i *ngIf="item.icon" class="{{ item.icon }}"></i>{{ item.label }}</a
                >
              }
            </li>
          </ul>
        </div>
      }
    </div>

    <ng-container *ngIf="sidebarFooterTemplate">
      <div class="sidebar-footer">
        <ng-container *ngTemplateOutlet="sidebarFooterTemplate"></ng-container>
      </div>
    </ng-container>
  }
</div>
